import { Component, OnInit } from '@angular/core';
import { EntityTypeCode } from 'projects/bis-shared/src/lib/utility/system-type-constants';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import { IdentityEntityGroup } from 'projects/bis-shared/src/lib/auth/security-models';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  readonly EntityType = EntityTypeCode;
  belongsToHealthcareProviderGroup: boolean = false;
  entityTypeCode: string;
  myGroups: IdentityEntityGroup[];
  systemUserId: number;
  redirectedToTabIndex: number;

  constructor(private identityService: IdentityService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.redirectedToTabIndex = +this.route.snapshot.queryParamMap.get('redirectToTab');
    this.myGroups = _.filter(this.identityService.identity.entityGroups, g =>
      _.some(g.userRoleCodes),
    );
    this.systemUserId = this.identityService.identity.userId;
    this.myGroups.forEach((entityGroup: IdentityEntityGroup) => {
      if (!this.belongsToHealthcareProviderGroup) {
        this.entityTypeCode = entityGroup.entityTypeCode;

        if (entityGroup.entityTypeCode === EntityTypeCode.HealthcareProvider) {
          this.belongsToHealthcareProviderGroup = true;
        }
      }
    });
  }
}
